const API = process.env.REACT_APP_API_URL || '';

export function api(path, opts = {}) {
  const token = localStorage.getItem('sqetrack_token') || '';
  return fetch(API + path, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    ...opts,
  }).then(r => {
    if (r.status === 401) {
      localStorage.removeItem('sqetrack_token');
      window.location.href = '/login';
      return {};
    }
    return r.json();
  });
}

// Fire-and-forget event tracker — never throws
export function trackEvent(event, properties = {}) {
  api('/api/events', {
    method: 'POST',
    body: JSON.stringify({ event, properties }),
  }).catch(() => {});
}

export function downloadExport() {
  const token = localStorage.getItem('sqetrack_token') || '';
  fetch(API + '/api/export', {
    headers: { 'Authorization': `Bearer ${token}` },
  })
    .then(r => r.blob())
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `SQE_Revision_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    });
}
